export const bytesToHuman = (bytes: number, decimals = 0): string => {
    if (bytes === 0) return '0 Байт';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Байт', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПТ', 'ЭБ', 'ЗБ', 'ЙБ'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}